/**
 * PostHog site-wide Shopify hooks — cart, variants, checkout, search, navigation.
 */
(function () {
  'use strict';

  function wph() {
    return window.whiskyPosthog;
  }

  function capture(event, properties) {
    var w = wph();
    if (w) {
      w.capture(event, properties);
      return;
    }
    if (typeof window.posthog !== 'undefined' && window.posthog.capture) {
      window.posthog.capture(event, properties || {});
    }
  }

  function waitFor(condition, callback, attempts) {
    var max = attempts || 50;
    var i = 0;
    var timer = setInterval(function () {
      i += 1;
      if (condition()) {
        clearInterval(timer);
        callback();
      } else if (i >= max) {
        clearInterval(timer);
      }
    }, 100);
  }

  function bindThemePubsub() {
    if (!window.theme || !window.theme.pubsub) return;

    var events = window.theme.pubsub.PUB_SUB_EVENTS;

    window.theme.pubsub.subscribe(events.cartUpdate, function (payload) {
      if (!payload || !payload.cart) return;

      var cart = payload.cart;
      var props = {
        source: payload.source || 'unknown',
        variant_id: payload.productVariantId || null,
        cart_total: typeof cart.total_price === 'number' ? cart.total_price / 100 : null,
        cart_item_count: cart.item_count,
        currency: cart.currency || null
      };

      var w = wph();
      if (w) props = w.funnelContext(props);

      if (
        payload.source === 'product-form' ||
        payload.source === 'product-bundle' ||
        payload.source === 'dragon-slayer-explorer' ||
        (payload.source && String(payload.source).indexOf('father') !== -1)
      ) {
        capture('product_added_to_cart', props);
      } else {
        capture('cart_updated', props);
      }
    });

    window.theme.pubsub.subscribe(events.cartError, function (payload) {
      capture('cart_error', {
        source: payload && payload.source,
        variant_id: payload && payload.productVariantId,
        message: payload && payload.message
      });
    });

    window.theme.pubsub.subscribe(events.variantChange, function (payload) {
      if (!payload || !payload.data) return;
      var variant = payload.data.variant;
      if (!variant) return;

      capture('product_variant_selected', {
        product_id: payload.data.product && payload.data.product.id,
        variant_id: variant.id,
        variant_title: variant.title,
        price: typeof variant.price === 'number' ? variant.price / 100 : null,
        available: variant.available
      });
    });

    window.theme.pubsub.subscribe(events.facetUpdate, function (payload) {
      capture('collection_filtered', {
        source: payload && payload.source
      });
    });
  }

  function bindNavigation() {
    var lastPath = window.location.pathname;

    function onPathChange() {
      var path = window.location.pathname;
      if (path === lastPath) return;
      lastPath = path;
      capture('spa_navigation', {
        pathname: path,
        search: window.location.search
      });
    }

    window.addEventListener('popstate', onPathChange);
    var pushState = history.pushState;
    var replaceState = history.replaceState;
    if (pushState) {
      history.pushState = function () {
        pushState.apply(history, arguments);
        onPathChange();
      };
    }
    if (replaceState) {
      history.replaceState = function () {
        replaceState.apply(history, arguments);
        onPathChange();
      };
    }
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    var detail = event.detail || {};
    var product = detail.product;
    if (!product) return;

    capture('product_added_to_cart', {
      source: 'ajaxProduct',
      variant_id: product.variant_id || product.id,
      product_title: product.title,
      quantity: product.quantity
    });
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest(
          '[href*="/checkout"], [name="checkout"], .cart__checkout-button, #checkout, [data-checkout-redirection="true"]'
        )
      : null;
    if (!target) return;

    capture('checkout_started', {
      trigger: target.tagName,
      href: target.getAttribute && target.getAttribute('href'),
      label: (target.textContent || '').trim().slice(0, 80)
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.getAttribute('action') && String(form.getAttribute('action')).indexOf('/search') !== -1) {
      var input = form.querySelector('input[name="q"]');
      capture('search_submitted', {
        search_terms: input ? input.value : '',
        source: 'form_submit'
      });
    }
  });

  bindNavigation();

  waitFor(function () {
    return window.theme && window.theme.pubsub;
  }, bindThemePubsub);
})();
